import { MenuItem, Typography } from '@mui/material'
import {
  dateOperators,
  equalityOperators,
  multiselectOperators,
  textOperators
} from '../../../utils/constants/operators'
import { Link } from 'react-router-dom'

export const getUserColumns = ({ roles = [] }) => [
  {
    name: 'firstname',
    label: 'Prénom',
    isFilter: true,
    operators: textOperators
  },
  {
    name: 'lastname',
    label: 'Nom',
    isFilter: true,
    operators: textOperators
  },
  {
    name: 'email',
    label: 'Email',
    isFilter: true,
    operators: textOperators
  },
  {
    name: 'role_id',
    label: 'Rôle',
    isFilter: true,
    valueEditorType: 'multiselect',
    values: roles.map(({ id, name: label }) => ({ name: String(id), label })),
    mapping: (id) => {
      const result = roles.find((item) => item.id === id)
      return (
        <Link to={`/roles/view`} state={{ id, history: '/users' }}>
          <Typography>{result ? result.name : id}</Typography>
        </Link>
      )
    },
    operators: [...equalityOperators, ...multiselectOperators]
  },
  {
    name: 'createdDateTime',
    label: 'Date Création',
    isFilter: true,
    inputType: 'datetime-local',
    type: 'date',
    format: 'DD/MM/YYYY HH:mm:ss',
    operators: dateOperators
  },
  {
    name: 'createdBy',
    label: 'Créé Par',
    isFilter: true,
    operators: textOperators
  },
  {
    name: 'lastModDateTime',
    label: 'Date Modification',
    isFilter: true,
    inputType: 'datetime-local',
    type: 'date',
    format: 'DD/MM/YYYY HH:mm:ss',
    operators: dateOperators
  },
  {
    name: 'lastModBy',
    label: 'Modifié Par',
    isFilter: true,
    operators: textOperators
  }
]

export const getUserFields = (modeProps, mode, attach, rolesList = [], user) => [
  [
    {
      tab: '1',
      name: 'logo',
      label: 'Avatar',
      type: 'avatar',
      file: (data) => data.attachments?.find((a) => a.type === 'user_logo'),
      isDisplay: () => modeProps !== 'wizard'
    }
  ],
  [
    {
      tab: '1',
      name: 'file',
      label: 'Logo',
      type: 'file',
      file: attach,
      isDisplay: () => modeProps !== 'wizard',
      validation: [
        { rule: 'fileSizeMax=1', error: 'Taille de fichier supérieure à 1MB, selectionner un fichier plus petit' },
        { rule: 'fileType=image', error: 'Fichier incorrect, selectionner un fichier image' }
      ]
    }
  ],
  [
    {
      tab: '1',
      name: 'firstname',
      label: 'Prénom',
      type: 'text',
      required: true,
      fullWidth: true,
      validation: [
        { rule: 'req', error: 'Prénom obligatoire' },
        { rule: 'minlen=3', error: 'Prénom doit contenir au moins 3 caractères' },
        { rule: 'maxlen=20', error: 'Prénom doit contenir moins de 20 caractères' }
      ]
    }
  ],
  [
    {
      tab: '1',
      name: 'lastname',
      label: 'Nom',
      type: 'text',
      required: true,
      fullWidth: true,
      validation: [
        { rule: 'req', error: 'Nom obligatoire' },
        { rule: 'minlen=3', error: 'Nom doit contenir au moins 3 caractères' },
        { rule: 'maxlen=20', error: 'Nom doit contenir moins de 20 caractères' }
      ]
    }
  ],
  [
    {
      tab: '1',
      name: 'email',
      label: 'Email',
      type: 'text',
      required: true,
      fullWidth: true,
      validation: [
        { rule: 'req', error: 'Email obligatoire' },
        { rule: 'email', error: 'Email format' },
        {
          rule: 'unique',
          object: 'user',
          condition: (data) => ({ email: data.email }),
          error: 'Email déjà utilisé',
          except: (res, data) => data.id === undefined || data.id !== res.data.id
        }
      ]
    }
  ],
  [
    {
      tab: '1',
      name: 'role_id',
      label: 'Rôle',
      type: 'select',
      required: true,
      options: {
        type: 'custom',
        component: (data) =>
          (rolesList || [])
            .filter((role) => {
              if (data.role?.is_admin && !user.role.is_grant_admin) return role.is_admin
              return role.is_admin ? user.role.is_grant_admin : true
            })
            .map((role) => (
              <MenuItem key={role.id} value={role.id}>
                {role.name}
              </MenuItem>
            ))
      },
      isDisplay: () => modeProps !== 'wizard',
      readOnlyWhen: (data) => !user.role.is_admin || (data.role?.is_admin && !user.role.is_grant_admin),
      fullWidth: true,
      validation: [{ rule: 'req', error: 'Rôle obligatoire' }]
    }
  ],
  [
    {
      tab: '1',
      name: 'password',
      label: 'Mot de passe',
      type: 'password',
      required: true,
      fullWidth: true,
      isDisplay: () => modeProps === 'wizard' || mode === 'add',
      validation: [
        { rule: 'req', error: 'Mot de passe obligatoire' },
        { rule: 'minlen=8', error: 'Mot de passe doit contenir au moins 8 caractères' }
      ]
    }
  ],
  [
    {
      tab: '1',
      name: 'repassword',
      label: 'Confirmation Mot de passe',
      type: 'password',
      required: true,
      fullWidth: true,
      isDisplay: () => modeProps === 'wizard' || mode === 'add',
      validation: [
        { rule: 'req', error: 'Confirmer le Mot de passe' },
        { rule: 'same=password', error: 'Mots de passe différents' }
      ]
    }
  ]
]

export const getUserSettingsFields = () => [
  [
    {
      name: 'oldpassword',
      label: 'Mot de passe',
      type: 'password',
      fullWidth: true,
      validation: [
        {
          rule: 'req',
          error: 'Mot de passe obligatoire'
        }
      ]
    }
  ],
  [
    {
      name: 'newpassword',
      label: 'Nouveau Mot de passe',
      type: 'password',
      fullWidth: true,
      validation: [
        {
          rule: 'req',
          error: 'Nouveau Mot de passe obligatoire'
        },
        {
          rule: 'minlen=8',
          error: 'Nouveau Mot de passe doit contenir au moins 8 caractères'
        },
        {
          rule: 'diff=oldpassword',
          error: 'Nouveau Mot de passe doit être différent du Mot de passe actuel'
        }
      ]
    }
  ],
  [
    {
      name: 'repassword',
      label: 'Confirmation Mot de passe',
      type: 'password',
      fullWidth: true,
      validation: [
        {
          rule: 'req',
          error: 'Confirmer le Mot de passe'
        },
        {
          rule: 'same=newpassword',
          error: 'Mots de passe différents'
        }
      ]
    }
  ]
]
